<template>
  <div class="content-message">
    <div class="top">
      <div class="title">影票定价</div>
      <div class="top-button" @click="batchClick()">批量修改</div>
    </div>
    <div class="search">
      <el-form class="search-from" ref="form" :model="searchForm" label-width="85px">
        <el-form-item label="影院名称">
          <el-input style="width: 160px;" v-model="searchForm.cinemaName" placeholder="请输入" size="small"></el-input>
        </el-form-item>
        <el-form-item label="选择城市">
          <el-select v-model="searchForm.cityId" placeholder="请选择" filterable size="small" :clearable="true">
            <el-option
              v-for="item in cityList"
              :key="item.cityId"
              :label="item.regionName"
              :value="item.cityId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div class="search-button">
          <div class="button-refer" @click="search">查询</div>
        </div>
      </el-form>
    </div>
    <div class="table">
      <div class="table-list">
        <el-table
          :data="list.list"
          style="width: 100%"
          :header-cell-style="bgColor"
          v-loading="loading"
          @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="80"
            align="center">
          </el-table-column>
          <el-table-column
            label="城市"
            width="180"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.cityName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="影院名称"
            width="180"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.cinemaName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="影院折扣（%）"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.discount }}%</span>
            </template>
          </el-table-column>
          <el-table-column
            label="最近修改时间"
            width="180"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.updateTime }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="180"
            align="center">
            <template slot-scope="{row}">
              <span class="span" @click="revamp(row)">修改折扣</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="table-left">
          已选择<span>{{selectList.length}}</span>条数据
        </div>
        <el-pagination
          v-if="list.total > 0"
          background
          class="align-right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="list.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="list.total">
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="修改折扣"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
     <div class="message-center" v-if="!isBatch">
       <div class="title"><span>*</span>影院折扣</div>
       <div class="input">
         <el-input style="width: 240px;" v-model="discount" placeholder="请输入0-100的整数" :max="100" :min="1"></el-input><span>%</span>
         <div class="text">请输入0~100的整数，用户支付金额=市场价*影院折扣</div>
       </div>
     </div>
      <div class="hint-message" v-else>
<!--        <div class="hint-message-title">确认修改所选<span>{{ selectList.length }}</span>家影院的折扣？</div>-->
        <div class="message-center" style="justify-content: start">
          <div class="title">统一折扣</div>
          <div class="input">
            <el-input style="width: 312px;" v-model="discountBatch" placeholder="请输入0-100的整数"></el-input><span>%</span>
            <div class="text">将所选影院设置为统一的折扣，若不修改则放空。参考基准为85折。</div>
          </div>
        </div>
        <div class="message-center" style="justify-content: start">
          <div class="title">调整折扣</div>
          <div class="input">
            <el-radio v-model="type" label="1">上调</el-radio>
            <el-radio v-model="type" label="2">下调</el-radio>
            <el-input style="width: 140px;" v-model="diffDiscount" placeholder="请输入0-100的整数" :max="100" :min="1"></el-input><span>%</span>
            <div class="text">将所选影院在原折扣基础上进行上调或下调，若不修改则放空。</div>
          </div>
        </div>
      </div>
      <div class="button">
        <div class="button-cancel" @click="dialogVisible = false">取消</div>
        <div class="button-confirm" @click="confirm()">确定</div>
      </div>
    </el-dialog>
    <modify-discount v-if="show" :show="show" :selectList="selectList" :discountBatch="discountBatch" :diffDiscount="diffDiscount" :type="type"></modify-discount>
  </div>
</template>

<script>
import modifyDiscount from "./components/modifyDiscount";
import { saasOrder} from "../../../../javaApi/saasOrder";
const SaasM = new saasOrder()
export default {
  name: "index",
  components:{
    modifyDiscount
  },
  data(){
    return{
      searchForm:{
        cinemaName:this.cinemaName,
        cityId:this.cityId,
        pageNo:1,
        pageSize:10
      },
      list:[],
      bgColor:{
        background: '#FCFAF8'
      },
      dialogVisible:false,
      isBatch:false, //是否批量修改
      options:[],
      radio:'',
      currentPage:1,
      selectList:[], // 已选中数据
      id:'',
      discount:'', // 折扣
      type:'',
      diffDiscount:'', //调整折扣
      discountBatch:'', // 批量折扣
      cityList:[],
      loading:true,
      show:false
    }
  },
  mounted() {
    this.getList()
    this.getCityList()
  },
  methods:{
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.searchForm.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchForm.pageNo = val
      this.getList()
    },
    // 表格多选批量修改
    handleSelectionChange(val){
      console.log(val)
      this.selectList = val
      console.log('selectList',this.selectList)
      let arr = []
      for(let index in this.selectList){
        arr.push(this.selectList[index].id)
      }
      this.ids = arr
    },
    handleClose(){
      this.dialogVisible = false
    },
    // 批量修改
    batchClick(){
      if(this.selectList.length == 0){
        this.$Message.error('请先选择要批量修改的数据')
        return
      }
      this.isBatch = true
      this.dialogVisible = true
    },
    // 获取数据
    getList(){
      let param = this.searchForm
      SaasM.moviePriceList(param).then(res=>{
        if(res.data.code == 200){
          this.list = res.data.data
          this.loading = false
        }else{
          this.$Message.error(res.data.info || res.data.message)
        }
      })
    },
    // 搜索
    search(){
      this.loading = true
      this.getList()
    },
    // 单独修改
    revamp(row){
      this.isBatch = false
      this.dialogVisible = true
      this.id = row.id
    },
    // 确定修改
    confirm(){
      let params
      if(this.discount.indexOf('-')!=-1 || this.discountBatch.indexOf('-')!=-1 || this.diffDiscount.indexOf('-')!=-1){
        this.$Message.error('不能输入负数')
        return;
      }
      // 批量修改
      if(this.isBatch){
        this.show = true
      }else {
        params = {
          id:this.id,
          discount:this.discount
        }
        SaasM.updateDiscount(params).then(res=>{
          if(res.data.code == 200){
            this.dialogVisible = false
            this.$Message.success('修改成功')
            this.discount = ''
            this.getList()
          }else{
            this.$Message.error(res.data.info || res.data.message)
          }
        })
      }
    },
    // 获取城市列表
    getCityList(){
      // select下来直接不分页全部请求显示所有城市
      let params = {
        pageNo:1,
        pageSize:350
      }
      SaasM.getCity(params).then(res=>{
        if(res.data.code == 200){
          this.cityList = res.data.data.list
        }else{
          this.$Message.error(res.data.info || res.data.message)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.content-message {
  background: #FFFFFF;
  border-radius: 8px;
  padding: 20px;
  min-height: 92%;
  .top{
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      font-size: 18px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #222222;
      line-height: 25px;
    }
    .top-button{
      width: 88px;
      height: 36px;
      background: #FF8622;
      border-radius: 2px;
      text-align: center;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #FFFFFF;
      line-height: 36px;
      cursor: pointer;
    }
  }
  .search{
    margin-top: 20px;
    display: flex;
    align-items: center;
    .search-from{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    .search-button{
      display: flex;
      align-items: center;
      margin-left: 20px;
      .button-refer{
        width: 76px;
        height: 32px;
        background: #FF8622;
        border-radius: 2px;
        text-align: center;
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 32px;
        cursor: pointer;
      }
      .button-export{
        width: 76px;
        height: 32px;
        background: #FFFFFF;
        border-radius: 2px;
        border: 1px solid #FF8622;
        text-align: center;
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #FF8622;
        line-height: 32px;
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
}
.table-left{
  font-size: 13px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #666666;
  line-height: 18px;
  margin-top: 20px;
  span{
    color: #FF8622;
  }
}
.table{
  margin-top: 20px;
}
.message-center{
  display: flex;
  justify-content: center;
  .title{
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #666666;
    line-height: 20px;
    margin-right: 10px;
    margin-top: 10px;

    span{
      color: #FF4F76;
    }
  }
  .input{
    .text{
      font-size: 12px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #999999;
      line-height: 17px;
      margin-top: 8px;
    }
    span{
      font-size: 16px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #666666;
      line-height: 22px;
      margin-left: 10px;
    }
  }
}
.button{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 43px;
  .button-cancel{
    width: 76px;
    height: 32px;
    border-radius: 2px;
    border: 1px solid #EEEEEE;
    text-align: center;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #222222;
    line-height: 32px;
    margin:0 10px;
    cursor: pointer;
  }
  .button-confirm{
    width: 104px;
    height: 32px;
    background: #FF8622;
    border-radius: 2px;
    text-align: center;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #ffffff;
    line-height: 32px;
    margin: 0 10px;
    cursor: pointer;
  }
}
.hint-message{
  .hint-message-title{
    font-size: 16px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #222222;
    line-height: 22px;
    margin-bottom: 20px;
    span{
      color: #FF4F76
    }
  }
}
/deep/.el-form-item{
  margin-bottom: 0;
}
.table{
  margin-top: 20px;
}
/deep/.el-form-item{
  margin-bottom: 0;
}
/deep/.el-dialog__header{
  border-bottom: 1px solid #e5e5e5;
}
/deep/.el-input__inner:focus{
  border-color: #FF8622!important;
}
/deep/.el-range-editor.is-active, .el-range-editor.is-active:hover{
  border-color: #FF8622!important;
}
/deep/.el-date-table td.today{
  background: #FF8622;
}
/deep/.el-input__inner:hover{
  background: #FCF8F5;
  border-color: #FF8622!important;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active{
  background: #FF8622!important;
}
.align-right{
  text-align: right;
  margin-top: 20px;
}
.span{
  color: #FF9734;
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/SaasJoin/moviePriceList/index.vue